<!--
 * @Description: 
-->
<!--
 * @Description: 扫码绑定
-->
<template>
    <div class="page">
        <van-nav-bar
                :title="$route.meta.title"
                fixed>
        </van-nav-bar>
        <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
        <div class="content">
            <van-image style="width:100%;" :src="require('../assets/images/u9066.png')"/>
            <div class="txt1">绍兴水务网上营业厅微信绑定确认</div>
            <div class="txt2">如不是本人操作、请勿确认</div>
            <van-button @click="confirm()" color="#1677FF" type="info" class="btn" style="margin-top:40px;">
                确认绑定
            </van-button>
            <!-- <van-button @click="cancel()" plain color="#1677FF" type="info" class="btn">
              取消
            </van-button> -->
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        methods: {
            confirm() {
                let code = this.$comm.GetQueryString('code')
                let token = this.$comm.GetQueryString('token')
                this.$http.post(this.$api.scanBindUrl, {
                    token: token,
                    code: code
                }).then(res => {
                    if (res.code === "000") {
                        // this.$toast('绑定成功')
                        this.$router.replace({
                            path: '/scanBindSuccess'
                        })
                    } else {
                        this.$toast(res.msg);
                    }
                });
            },
            cancel() {
                this.$router.go(-1)
            }
        },
    }
</script>

<style lang="less" scoped>
    .scan-bind {
        height: 100%;
        background: rgb(248, 248, 248);

        .content {
            padding: 40px;
            text-align: center;

            .txt1 {
                margin-top: 20px;
                font-size: 16px;
            }

            .txt2 {
                margin-top: 20px;
                color: red;
                font-size: 14px;
            }

            .btn {
                margin-top: 20px;
                width: 100%;
            }
        }
    }
</style>